/** Etiqueta pequeña + valor: la celda de los datos de la ficha. */
export default function Dato({ label, children }) {
  return (
    <div className="min-w-0">
      <p className="text-micro text-neutral-500 dark:text-neutral-400 uppercase tracking-wide">{label}</p>
      <p className="text-body-sm text-neutral-800 dark:text-neutral-200 mt-0.5 break-words">{children ?? '—'}</p>
    </div>
  )
}
